@if (!standalone) {
  <div
    class="pl-base flex items-center justify-between bg-gray-50"
    [ngClass]="{ '!p-sm': !enableRangePickerType }"
  >
    <div class="text-sm leading-sm text-txt-secondary">Select dates</div>
    @if (enableRangePickerType) {
      <lla-tabs
        class="block -mb-[1px]"
        [sections]="allCalendarTypes"
        (selectedSectionChanged)="onSelectorTypeChange($event)"
        [selectedSection]="rangePickerType"
        extraTabItemClass="p-sm! md:!px-lg text-sm!"
      ></lla-tabs>
    }
  </div>
}

<div
  class="flex-1 flex flex-col md:flex-row md:border-t md:border-gray-100"
  [ngClass]="{
    'border-b': standalone,
    'pt-lg md:pt-0 border-t border-gray-100': enableRangePickerType
  }"
>
  @if (!hideAllPeriods) {
    <div class="pills-container" [ngClass]="{ '!pl-0': standalone }">
      @for (item of periodTypeButtonsInfo; track item) {
        <lla-pill
          class="md:hidden"
          extraClass="w-max min-w-max"
          [selected]="value?.periodType === item.value"
          [label]="item.label"
          size="m"
          (click)="setDateByPeriodType(item)"
        >
        </lla-pill>
      }
      @for (item of periodTypeButtonsInfo; track item) {
        <lla-pill
          class="hidden md:block w-full"
          extraClass="w-full min-w-max"
          [selected]="value?.periodType === item.value"
          [label]="item.label"
          size="s"
          (click)="setDateByPeriodType(item)"
        >
        </lla-pill>
      }
    </div>
  }

  <div class="flex-1 flex flex-col">
    <form
      [formGroup]="rangeForm"
      class="flex items-center mb-sm md:mb-xs -mt-sm pt-2xl md:pt-lg px-base md:pb-0"
      [ngClass]="{ '!px-0 md:!px-base': standalone }"
    >
      <div class="flex-1" [ngClass]="{ 'lla-selected-input': focusInput === 'start' }">
        <lla-input
          class="w-full"
          size="small"
          controlName="fromText"
          [label]="rangePickerType === 'monthly' ? 'Start month' : 'Start date'"
          type="text"
          (inputFocus)="focusInput = 'start'; setCalendarActiveDate(rangeForm.get('from')?.value)"
          (inputFocusOut)="setFromText(fromControl?.value)"
        ></lla-input>
      </div>
      <div class="px-xs text-txt-secondary">-</div>
      <div class="flex-1" [ngClass]="{ 'lla-selected-input': focusInput === 'end' }">
        <lla-input
          class="w-full"
          size="small"
          controlName="toText"
          [label]="rangePickerType === 'monthly' ? 'End month' : 'End date'"
          type="text"
          (inputFocus)="focusInput = 'end'; setCalendarActiveDate(rangeForm.get('to')?.value)"
          (inputFocusOut)="setToText(toControl?.value)"
        ></lla-input>
      </div>
    </form>

    <div class="flex-1 px-xs pb-0" [ngClass]="{ '!pb-0 !px-0': standalone }">
      <mat-calendar
        #calendar
        class="mg-date-range-picker-calendar"
        [ngClass]="{
          'monthly-mode': rangePickerType === 'monthly',
          'weekly-mode': rangePickerType === 'weekly',
          'daily-mode': rangePickerType === 'daily'
        }"
        [selected]="selectedDateRange"
        (selectedChange)="onSelectedDateChange($event)"
        [maxDate]="calendarMaxDate"
        [minDate]="minDate ?? undefined"
        [startView]="calendarStartView"
        (yearSelected)="onYearSelected($event)"
        (viewChanged)="onViewChanged($event)"
      ></mat-calendar>
    </div>
  </div>
</div>

@if (!standalone) {
  <div class="hidden md:flex items-center justify-end p-base border-t border-ui-separator">
    <lla-button class="mr-2xl" variant="ghost" size="medium-shrink" (click)="canceld.emit()">
      Cancel
    </lla-button>
    <lla-button
      variant="ghost"
      size="medium-shrink"
      extraBtnClass="!text-primary"
      (click)="fireValueChangedEvent()"
    >
      Apply
    </lla-button>
  </div>

  <div class="px-base flex md:hidden flex-col gap-xs">
    <lla-button size="medium" (click)="fireValueChangedEvent()"> Apply </lla-button>
    <lla-button variant="ghost" size="medium" extraBtnClass="!text-primary" (click)="canceld.emit()">
      Cancel
    </lla-button>
  </div>
}
